import { IS_SUBJECT } from "../actions/actionTypes";
const initialState = {
  isSubject: false,
};

export default function (state = initialState, action) {
  //  (action.payload);
  switch (action.type) {
    case IS_SUBJECT:
      return {
        ...state,
        isSubject: action.payload,
      };

    default:
      return state;
  }
}
